import type { CreativeBriefResponse } from '@innovationdepartment/proxima-sdk-axios';

import BriefPanelView from './CreativeBriefs.BriefPanel.View';

type BriefPanelContainerProps = {
  brief: CreativeBriefResponse | null;
  isOpen: boolean;
  onClose: () => void;
  loading?: boolean;
};

const BriefPanelContainer = ({ brief, isOpen, onClose, loading }: BriefPanelContainerProps) => (
  <BriefPanelView brief={brief} isOpen={isOpen} onClose={onClose} loading={loading} />
);

export default BriefPanelContainer;
